import { createFeature } from '@ngrx/store';

import { userSettingsReducer } from './user-settings.reducer';

export const userSettingsFeatureKey = 'userSettings';

export const userSettingsFeature = createFeature({
  name: userSettingsFeatureKey,
  reducer: userSettingsReducer,
});
